import axios from "axios";
import switchAPI from "./switchAPI";

axios.defaults.withCredentials = true;

export const allBlogsAPI = `${switchAPI}/blogs/get-all-blogs`;